import React from 'react';
import { useFieldAttributes } from '../../../services/field-attributes';
import { DateTimeFieldWUT } from '../../../ui/date-time-field/date-time-field-wut';
import { getDateTimePartsErrors } from '../../../ui/date-time-field/date-time-field-utils';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldLabelWUT } from '../../../ui/field-label/field-label-wut';
import { Widget } from '../../../ui/widget/widget';
export const DateTimeInputWUT = _ref => {
  let {
    id,
    description,
    target,
    value,
    error,
    hasError = false,
    errorMessage,
    required,
    label,
    hideLabel,
    FieldLayout,
    use24HourFormat,
    disabled,
    hidePlaceholder,
    showDateLabels,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    onBlur,
    onFocus,
    onChange,
    widgetHtml,
    widgetEnabled
  } = _ref;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(FieldLabelWUT, {
      labelId: labelId,
      required: required,
      label: label,
      hideLabel: hideLabel,
      requiredIndicatorType: requiredIndicatorType,
      requiredIndicatorPlacement: requiredIndicatorPlacement
    }),
    renderInput: () => widgetHtml && widgetEnabled ? /*#__PURE__*/React.createElement(Widget, {
      fieldId: id,
      widgetHtml: widgetHtml,
      onChange: onChange,
      value: value
    }) : /*#__PURE__*/React.createElement(DateTimeFieldWUT, {
      use24HourFormat: use24HourFormat,
      onBlur: onBlur,
      onChange: onChange,
      onFocus: onFocus,
      value: value ?? '',
      id: id,
      disabled: disabled,
      hidePlaceholder: hidePlaceholder,
      showDateLabels: showDateLabels,
      required: required,
      errors: getDateTimePartsErrors(hasError, value ?? ''),
      inputId: inputId,
      ariaLabelledBy: labelId,
      ariaDescribedBy: ariaDescribedBy
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }))
  });
};
//# sourceMappingURL=date-time-input-wut.js.map